module.exports = __webpack_public_path__ + "img/unionpay.3abd59a2.svg";